import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

function GrayFade({isGrayFade, children, className}) {
	const _className = `StyledGrayFade${className ? ' ' + className : ''}${isGrayFade ? ' grayFade' : ''}`;

	return <StyledGrayFade className={_className}>{children}</StyledGrayFade>;
}

GrayFade.propTypes = {
	isGrayFade: PropTypes.bool,
	children: PropTypes.node,
	className: PropTypes.string
};

GrayFade.defaultProps = {
	isGrayFade: false,
	className: 'gray-fade'
};

export default GrayFade;

const StyledGrayFade = styled.section`
	transition: opacity 0.5s;
	opacity: inherit;
	pointer-events: inherit;
	&.grayFade {
		pointer-events: none;
		.StyledMESTSwitcherContentDropdown {
			opacity: 0.7;
			pointer-events: none;
		}
	}
`;
